<!--基础卡片类-->
<template>
    <div class="BaseCard">

<!--        普通卡片-->
        <div v-if="cardType === 'default'" class="itemLink shadowRadius" @click="onClick">
            <div class="image singleRadius">
                <img :src="imgUrl?imgUrl:'https://dcdn.thecover.cn/zxrobot/defaultNew.png'" :alt="name" class="imageWra">
            </div>
            <div class="contentBox" :style="{'color':`${color}`}">{{name}}</div>
        </div>

<!--        新闻类卡片-->
        <div v-else-if="cardType === 'news'" class="itemLink shadowRadius largeCard" @click="onClick">
            <div class="image singleRadius">
                <img :src="imgUrl?imgUrl:'https://dcdn.thecover.cn/zxrobot/defaultNew.png'" :alt="name" class="imageWra">
                <div class="play" v-if="newsKind=='v'&&cardType=='news'"><img src="https://dcdn.thecover.cn/zxrobot/play.png" alt="播放"></div>
            </div>
            <div class="contentBox" :style="{'color':`${color}`}">
                <div class="leftMark">
                    <img :src="require(`../../assets/img/${isChat?'chat':cardKey<3?'hot':'recom'}.png`)" alt="状态" class="imgView">
                </div>
                {{name}}
            </div>
        </div>

<!--        旅游类卡片-->
        <div v-else-if="cardType === 'tour'" class="itemLink shadowRadius largeCard" @click="onClick">
            <div class="image singleRadius">
                <img :src="imgUrl?imgUrl:'https://dcdn.thecover.cn/zxrobot/defaultNew.png'" :alt="name" class="imageWra">
            </div>
            <div class="tourBox">
                <div class="nameStar">
                    <div class="name">{{name||"地名"}}</div>
                    <div class="distance">{{distance}}km</div>
                </div>
                <div class="starBox">
                    <div v-for="(it,ix) in createArray(star>5?5:star)" :key="`it-${ix}`" class="arrayBox"><img
                            :src="require(`../../assets/img/${it.star}.png`)" alt="" class="starImg"></div>
                </div>
                <div class="area">地点： {{area}}</div>
            </div>
        </div>

<!--        历史上的今天卡片-->
        <div v-else-if="cardType === 'old'" class="itemLink shadowRadius oldCard" @click="onClick">
            <div class="image singleRadius">
                <img :src="imgUrl?imgUrl:'https://dcdn.thecover.cn/zxrobot/defaultNew.png'" :alt="name" class="oldImageWra">
            </div>
            <div class="contentBox" :style="{'color':`${color}`}">
                <div v-if="cardType=='old'" class="leftYear">{{year}}</div>
                {{name}}
            </div>
        </div>

<!--        音频组件卡片-->
        <div v-else-if="cardType === 'audio'" class="itemLink shadowRadius" @click="onClick">
            <div class="image">
                <img :src="imgUrl?imgUrl:'https://dcdn.thecover.cn/zxrobot/defaultNew.png'" :alt="name"  class="imageWra">
                <div class="audioInfo">
                    <div v-if="hasNews" class="new">已更新{{hasNews}}篇</div>
                    <div class="playButtom"><img src="https://dcdn.thecover.cn/zxrobot/play.png" alt="播放"></div>
                </div>
            </div>
            <div class="contentBox" :style="{'color':`${color}`}">{{name}}</div>
        </div>

<!--        电影类卡片-->
        <div v-else-if="cardType === 'movie'" class="itemLink shadowRadius" @click="onClick">
            <div class="image singleRadius movieImageWra">
                <img :src="imgUrl?imgUrl:'https://dcdn.thecover.cn/zxrobot/defaultNew.png'" :alt="name"  class="imageWra">
                <div class="rateInfo">
                    评分
                    <span>{{star}}</span>
                </div>
            </div>
            <div class="movieContentBox" :style="{'color':`${color}`}">{{name}}</div>
        </div>
    </div>

</template>

<script>
    import {createArray} from "@/utils/utils";

    export default {
        name: "BaseCard",
        components: {},
        props: {
            imgUrl: {
                type: String,
                default: ""
            },
            name: {
                type: String,
                default: ""
            },
            color: {
                type: String,
                default: ""
            },
            cardType: {
                type: String,
                default: "default"  //news 新闻类  //old 历史上的今天  //tour 旅游 //audio 音频 //movie 电影
            },
            cardKey: {
                type: Number,
                default: 0
            },
            isChat: {
                type: Boolean,
                default: false
            },
            newsKind: {
                type: String,
                default: 'n'
            },
            year: {
                type: String,
                default: ""
            },
            distance: {
                type: Number,
                default: 0
            },
            star: {
                type: Number | String,
                default: 0
            },
            area: {
                type: String,
                default: ""
            },
            hasNews: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {

            };

        },
        methods: {
            onClick() {
                this.$emit("on-click");
            },
            createArray(n) {
                return createArray(n, 1);
            }
        }
    };
</script>
<style lang="less" scoped>
    @import "../../assets/less/common";

    .BaseCard {
        padding-right: .35rem;

        .largeCard {
            width: 7.6rem !important;

        }

        .oldCard {
            width: auto !important;
            padding: .15rem .15rem 0;
            .leftYear {
                font-size: .4rem;
                font-weight: 600;
                font-family: PangMenZhengDao;
                color: @font-dark-color;
                display: inline-block;
            }
        }

        .itemLink {
            width: 4rem;
            font-size: .35rem;
            color: @font-base-color;
            background: rgba(255, 255, 255, 1);

            text-align: center;
            cursor: pointer;

            flex: 0 0 auto;
            /*margin: .15rem 0;*/
            overflow: hidden;

            .image {
                width: 100%;
                height: 4rem;
                overflow: hidden;
                position: relative;
            }
            .movieImageWra{
                width: 100%;
                height: 5.6rem;
                overflow: hidden;
                position: relative;
            }
            .imageWra {
                width: 100%;
                max-width: 100%;
                height: 100%;
            }
            .oldImageWra{
                width: auto;
                min-width: 4rem;
                /*width: 100%;*/
                /*max-width: 100%;*/
                min-height: 100%;
            }

            .play {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);

                img {
                    width: 1.5rem;
                    height: 1.5rem;
                }
            }

            .tourBox {
                text-align: left;
                min-height: 1.5rem;
                line-height: .6rem;
                margin: .3rem .25rem;
                overflow: hidden;


            }

            .contentBox {
                text-align: left;
                min-height: 1.2rem;
                line-height: .6rem;
                margin: .3rem .25rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                .leftMark {
                    vertical-align: sub;
                    display: inline-block;
                    color: #fff;
                    font-size: .42rem;

                    .imgView {
                        width: .5rem;
                        height: .5rem;
                    }

                }
            }
            .movieContentBox{
                text-align: left;
                height: .6rem;
                line-height: .6rem;
                margin: .3rem .25rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        .audioInfo{
            .new{
                position: absolute;
                left: 0;
                bottom: 0;
                height: .53rem;
                background-color: #426CF2;
                padding: .11rem .27rem;
                border-radius: .11rem;
                font-size: .32rem;
                color: #fff;
                line-height: .53rem;
                text-align: center;
            }
            .playButtom{
                position: absolute;
                right: .16rem;
                bottom: .11rem;
                width: .43rem;
                height: .43rem;
            }
        }
        .rateInfo{
            position: absolute;
            left: .21rem;
            bottom: .21rem;
            height: 0.37rem;
            font-size: .37px;
            line-height: .37rem;
            color: #F7CC45;
            span{
                margin-left: .03rem;
                font-size: 0.53rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #F7CC45;
                line-height: 0.37rem;
            }
        }
    }

</style>
